import React from 'react';
import { ExclamationCircleFilled } from '@ant-design/icons'
import './index.scss'

function Qualification() {
  return (
    <>
      <div className="qualification-container">
        <div className="tip">
          <ExclamationCircleFilled className='tip-icon' />不同店铺类型，入驻所需资料不同，请根据您的实际情况进行选择
        </div>
        <div className="content">
          <div className="content-header">
            <span className='header-text'>类型</span>
            <span className='header-text'>所需资质</span>
            <span className='header-text'>简述</span>
          </div>
          <div className="content-body">
            <div className="row">
              <span className='row-text'>个人</span>
              <span className='row-text'>身份证正反面</span>
              <span className='row-text'>
                1、证件清晰，建议用扫描件上传<br />
                2、中国大陆身份证
              </span>
            </div>
            <div className="row">
              <span className='row-text'>个体工商户</span>
              <span className='row-text'>个体工商户营业执照</span>
              <span className='row-text'>个体工商户营业执照</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Qualification;
